import { useSocketClient } from 'providers/SocketContext';
import { useEffect, useRef } from 'react';
import type { Events } from 'services/socket/SocketClient';

export function useSocketEventListener<T>(event: Events, handler: (payload: T) => void | Promise<T | void>, enabled = true) {
  const socketClient = useSocketClient()?.socketClient;
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!socketClient || !enabled) return;

    const listener = (payload: T) => handlerRef.current(payload);
    socketClient.subscribe(event, listener);

    return () => {
      socketClient.unSubscribe(event, listener);
    };
  }, [socketClient, event, enabled]);
}
